import { PricingModules, SYSTEM_MODE } from '../../../../context/contexts/PricingModuleContext';
// can't shorten import- causes circular dependency
import { SHOWSTOPPER_PROP_OPTIONS, TOOLTIP_PROP_OPTIONS } from '../../../common/LockedFeatures/consts';

export enum DisabledDisplayOptions {
    HIDDEN = 'hidden',
    TOOLTIP = 'tooltip',
    SHOWSTOPPER = 'showstopper'
}

export enum RequiredModuleState {
    ANY_ENABLED = 'anyEnabled',
    ON_PREM_ENABLED = 'onPremEnabled',
    CLOUD_ENABLED = 'cloudEnabled',
    ALL_ENABLED = 'allEnabled'
}

type DisplayConfigOptions =
    | Pick<TooltipDisplayConfig, 'disabledDisplayOption' | 'tooltipProps'>
    | Pick<ShowstopperDisplayConfig, 'disabledDisplayOption' | 'showstopperProps'>
    | DisplayConfigOther;

type ModuleRequirement = DisplayConfigOptions & {
    requiredState: RequiredModuleState;
};

export type EnabledByModulesValue = RequiredModuleState | ModuleRequirement;
export type EnabledByModulesType = Partial<Record<PricingModules, EnabledByModulesValue>>;

interface DisplayConfigBase {
    disabledDisplayOption: DisabledDisplayOptions;
    hiddenBySystemModes?: SYSTEM_MODE[];
    enabledByModules?: EnabledByModulesType;
    moduleMatchLogic?: 'ALL' | 'ANY';
}

interface DisplayConfigOther extends DisplayConfigBase {
    disabledDisplayOption: Exclude<
        DisabledDisplayOptions,
        DisabledDisplayOptions.TOOLTIP | DisabledDisplayOptions.SHOWSTOPPER
    >;
}

export interface TooltipDisplayConfig extends DisplayConfigBase {
    disabledDisplayOption: DisabledDisplayOptions.TOOLTIP;
    tooltipProps: (typeof TOOLTIP_PROP_OPTIONS)[keyof typeof TOOLTIP_PROP_OPTIONS];
}

export interface ShowstopperDisplayConfig extends DisplayConfigBase {
    disabledDisplayOption: DisabledDisplayOptions.SHOWSTOPPER;
    showstopperProps: (typeof SHOWSTOPPER_PROP_OPTIONS)[keyof typeof SHOWSTOPPER_PROP_OPTIONS];
}

export type DisplayConfig = ShowstopperDisplayConfig | TooltipDisplayConfig | DisplayConfigOther;
